export function scrollToElement(ref: HTMLElement) {
    const scrollMarginTop = Number.parseInt(ref?.style.scrollMarginTop);
    const offset = ref.offsetTop - (scrollMarginTop || 0);
    // We cannot use Scrollintoview because the snackbars clutters the DOM en then the scrolling stops
    window.scrollTo({ top: offset, left: 0, behavior: "smooth" });
}
